import { render } from "./ToolbarItem.vue?vue&type=template&id=d1f6c398"
import script from "./ToolbarItem.vue?vue&type=script&lang=js"
export * from "./ToolbarItem.vue?vue&type=script&lang=js"

import "./ToolbarItem.vue?vue&type=style&index=0&id=d1f6c398&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__